import React from "react";
import { Fragment, FunctionComponent } from "react";
import RichTextProps from "./RichTextProps.interface";

import getProcessedRichText from "./helpers/getProcessedRichText";



const RichText: FunctionComponent<RichTextProps> = (props) => {
    const processedBodyText = getProcessedRichText(props.innerHtml);

    return (
        <Fragment>
            {props.innerHtml ? (
                <div className={props.className} dangerouslySetInnerHTML={processedBodyText}></div>
            ) : null}
        </Fragment>
    );
};

export default RichText;